// extracted by mini-css-extract-plugin
module.exports = {"Container":"kycScreen_Container__1kgPA","ModalClose":"kycScreen_ModalClose__2YArL","ModalClose_stepper":"kycScreen_ModalClose_stepper__2AHbk"};